var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',_vm._b({staticClass:"ds-base-icon"},'v-icon',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.iconSvg[_vm.iconName] || _vm.mdiHelpCircleOutline)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }